import ServiceBase from './serviceBase';
import {
  FlowCreate,
  FlowContainer,
  FlowNextReview,
  FlowFeedbackProvided,
  OperFlowService,
  FlowFeedbackForSave,
  InviteReviewers,
  FlowRestart,
  FlowRelate,
  FlowReviewerDelete,
  FlowEsapInfo,
  FlowSprMission,
  FlowSprDoc,
} from './types/Flow';

const NOT_IMPLEMENTED_ERROR_MESSAGE = 'Not Implemented';

class OperSupervisionReportService extends ServiceBase implements OperFlowService {
  create = async (data: FlowCreate): Promise<number> =>
    this.post<number>('operationsr/create', data);

  getFlow = async (operationId: number): Promise<FlowContainer> =>
    this.get<FlowContainer>(`operationsr/${operationId}`);

  sendForNextReview = async (data: FlowNextReview): Promise<void> =>
    this.post<void>('operationsr/next', data);

  provideFeedback = async (data: FlowFeedbackProvided): Promise<void> =>
    this.post<void>('operationsr/feedback', data);

  saveFeedback = async (data: FlowFeedbackForSave): Promise<void> =>
    this.post<void>('operationsr/savefeedback', data);

  applyComplianceChanges = async (flowId: number): Promise<void> =>
    this.post<void>(`operationsr/${flowId}/applycompliance`);

  discardComplianceChanges = async (flowId: number): Promise<void> =>
    this.post<void>(`operationsr/${flowId}/discardcompliance`);

  applyActionPlanChanges = async (flowId: number): Promise<void> =>
    this.post<void>(`operationsr/${flowId}/applyactionplans`);

  discardActionPlanChanges = async (flowId: number): Promise<void> =>
    this.post<void>(`operationsr/${flowId}/discardactionplans`);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- firma de OperFlowService, aun no implementado
  applyIndicatorsChanges = async (flowId: number): Promise<void> => {
    throw new Error(NOT_IMPLEMENTED_ERROR_MESSAGE);
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- firma de OperFlowService, aun no implementado
  discardIndicatorsChanges = async (flowId: number): Promise<void> => {
    throw new Error(NOT_IMPLEMENTED_ERROR_MESSAGE);
  };

  openWord = async (flowId: number): Promise<string> =>
    this.post<string>(`operationsr/${flowId}/wordlink`);

  downloadDocVersion = async (id: number): Promise<boolean> => {
    await this.download(`operationsr/version/${id}`);
    return true;
  };

  upload = async (formData: FormData): Promise<boolean> =>
    this.post<boolean>('operationsr/upload', formData);

  restart = async (data: FlowRestart): Promise<void> =>
    this.post<void>('operationsr/restart', data);

  relate = async (data: FlowRelate): Promise<void> => this.post<void>('operationsr/relate', data);

  inviteReviewers = async (data: InviteReviewers): Promise<void> =>
    this.post<void>('operationsr/invite-reviewers', data);

  removeReviewers = async (data: FlowReviewerDelete): Promise<void> =>
    this.post<void>('operationsr/remove-reviewers', data);

  getSPRRationale = async (flowId: number): Promise<FlowSprDoc> =>
    this.get<FlowSprDoc>(`operationsr/${flowId}/sprrationale`);

  getSPRMissions = async (flowId: number): Promise<FlowSprMission[]> =>
    this.get<FlowSprMission[]>(`operationsr/${flowId}/sprmissions`);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  checkEsap = async (flowId: number): Promise<FlowEsapInfo> => {
    throw new Error(NOT_IMPLEMENTED_ERROR_MESSAGE);
  };

  deleteFlow = async (flowId: number, lap?: number | undefined) => {
    let uri = `operationsr/${flowId}`;
    if (lap) {
      uri = `${uri}/${lap}`;
    }
    return this.delete<void>(uri);
  };
}

const operSupervisionReportService = new OperSupervisionReportService();

export default operSupervisionReportService;
